import HomepageSection from "./HomepageSection";

export default function HomepageSectionByType({
    sections = [],
    type,
}) {
    const section = sections.find(
        (section) => section.type === type
    );

    if (!section) {
        return null;
    }

    return (
        <HomepageSection
            section={section}
        />
    );
}